// Ruta base de la app (sin dependencias, para que las secciones y el cotizador
// naveguen sin importar config.tsx, que a su vez importa las secciones).
// Se llama "finanzas-operativas" y no "finanzas" porque esa familia ya existe
// (Finanzas internas: gastos/nómina, apagada en WAYAK) — ver config/apps/types.ts.
export const FINANZAS_OPERATIVAS_BASE = "/finanzas-operativas";
export const FINANZAS_OPERATIVAS_APP_ID = "finanzas-operativas";
